"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentVisibilityVisibilityEnum = void 0;
exports.instanceOfDocumentVisibility = instanceOfDocumentVisibility;
exports.DocumentVisibilityFromJSON = DocumentVisibilityFromJSON;
exports.DocumentVisibilityFromJSONTyped = DocumentVisibilityFromJSONTyped;
exports.DocumentVisibilityToJSON = DocumentVisibilityToJSON;
exports.DocumentVisibilityToJSONTyped = DocumentVisibilityToJSONTyped;
/**
 * @export
 */
exports.DocumentVisibilityVisibilityEnum = {
    SystemOnly: 'system_only',
    Public: 'public',
    Private: 'private'
};
/**
 * Check if a given object implements the DocumentVisibility interface.
 */
function instanceOfDocumentVisibility(value) {
    return true;
}
function DocumentVisibilityFromJSON(json) {
    return DocumentVisibilityFromJSONTyped(json, false);
}
function DocumentVisibilityFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'visibility': json['visibility'] == null ? undefined : json['visibility'],
    };
}
function DocumentVisibilityToJSON(json) {
    return DocumentVisibilityToJSONTyped(json, false);
}
function DocumentVisibilityToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'documentId': value['documentId'],
        'visibility': value['visibility'],
    };
}
